import { SECOND_EXCHANGE, THIRD_EXCHANGE } from "MODULES/SalesOrders/constants";

export const isLastExchange = lineItem =>
  (lineItem.purchase_for_exchange &&
    !lineItem.second_exchange_item_id &&
    !lineItem.exchange_type) ||
  (lineItem.exchange_type === SECOND_EXCHANGE &&
    !lineItem.third_exchange_item_id) ||
  lineItem.exchange_type === THIRD_EXCHANGE;

export const purchaseOrderLastExchange = purchaseOrder =>
  purchaseOrder.line_items.find(l => isLastExchange(l));

export const displayCost = lineItem =>
  lineItem.purchase_for_exchange && !lineItem.outright
    ? lineItem.exchange_fee
    : lineItem.cost;



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/shared/helpers.js